export enum RaffleCollectionStatus {
  Uncollected = 'uncollected',
  Collected = 'collected',
}
